import cx from "classnames";
import { Maybe } from "graphql/jsutils/Maybe";
import { RACING_RUNNER_ODDS_SELECTED } from "@/constants/amplitude";
import { Hr_Runner } from "@/graphql/gql/graphql";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import { makeSnakeCase } from "@/utils/horseRacing";
import styles from "./tableCells.module.scss";

interface OddsBtnProps {
  runner: Hr_Runner;
  numerator: string | number | undefined;
  fdrLink: string;
  denominator: string | number | undefined;
  raceNumber: Maybe<string> | number | undefined;
  trackName: Maybe<string> | undefined;
  disabled?: boolean;
}

const OddsBtn = ({
  runner,
  numerator,
  fdrLink,
  denominator,
  raceNumber,
  trackName,
  disabled,
}: OddsBtnProps) => {
  const { logAmplitudeEvent } = useAmplitude();
  const runnerName: string | undefined = makeSnakeCase(runner.horseName);
  const snakeTrackName = makeSnakeCase(trackName);
  const odds = `${numerator}/${denominator ?? 1}`;

  return runner.scratched ? (
    <p className={styles.scratchedLabel}>Scratched</p>
  ) : (
    <>
      {numerator &&
        (!disabled ? (
          <a
            onClick={() => {
              logAmplitudeEvent(RACING_RUNNER_ODDS_SELECTED, {
                "Track Name": snakeTrackName ?? "track_name_unknown",
                "Race Number": raceNumber ?? "Unknown Race Number",
                "Runner Name": runnerName ?? "unknown_horse_name",
                "Link URL": fdrLink,
              });
            }}
            className={styles.oddsLink}
            target="_blank"
            href={fdrLink}
            rel="noreferrer"
          >
            {odds}
          </a>
        ) : (
          <button
            type="button"
            disabled
            className={cx(styles.oddsLink, styles.oddsLinkDisabled)}
          >
            {odds}
          </button>
        ))}
    </>
  );
};

export default OddsBtn;
